module.exports = __webpack_public_path__ + "static/fastest-implementation-6173ab3f564fa565f4ab6f6b3545d8bb.svg";